import { useUser } from 'store'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'


const useCategoryContact = () => {
  const [user] = useUser()
  const { t } = useTranslation()
  const { setValue, watch } = useFormContext()
  const adminUsersRole = watch('roles.admin_users_role') || 'none'

  const items = [
    {
      key: 'admin_both',
      show: user?.admin || (user?.roles['admin_contact'] && user?.roles['admin_roles']),
      label: t('auth.admin.role.admin_roles_and_contact'),
      tooltip: t('auth.admin.role.tooltip.admin_roles_and_contact'),
      icon: <i className="fa-solid fa-crown" />,
      labelColor: '#92BC62',
      checked: adminUsersRole === 'admin_both',
      onChange: () => {
        setValue('roles.admin_users_role', 'admin_both')
        setValue('roles.admin_contact', true)
        setValue('roles.admin_roles', true)
        setValue('roles.readonly_contact', false)
      }
    },
    {
      key: 'readonly',
      show: true,
      label: t('auth.admin.role.readonly_contact'),
      tooltip: t('auth.admin.role.tooltip.readonly_contact'),
      checked: adminUsersRole === 'readonly',
      onChange: () => {
        setValue('roles.admin_users_role', 'readonly')
        setValue('roles.readonly_contact', true)
        setValue('roles.admin_contact', true)
        setValue('roles.admin_roles', false)
      }
    },
    {
      key: 'none',
      show: true,
      label: t('auth.admin.role.no_management'),
      tooltip: t('auth.admin.role.tooltip.no_management'),
      checked: adminUsersRole === 'none',
      onChange: () => {
        setValue('roles.admin_users_role', 'none')
        setValue('roles.admin_roles', false)
        setValue('roles.admin_contact', false)
        setValue('roles.readonly_contact', false)
      }
    }
  ]

  return {
    roles: items.filter(button => button.show)
  }
}

export default useCategoryContact